export const NotFound = () => {
  return (
    <>
      <p>The page could not be found.</p>
    </>
  );
};
